export default {
   PROGRAMMED: 'PROGRAMMED',
   FINISHED: 'FINISHED',
   CANCELLED: 'CANCELLED',
};
